// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import CurrentBoardHeaderUtil from '../CurrentBoardHeaderUtil';
import PopupToolButton from '../../../../components/popupPanel/PopupToolButton';
import Icon from '../../../../components/icons/Icon';
import PopupPanel from '../../../../components/popupPanel/PopupPanel';
import CurrentBoardMenuPopup from './CurrentBoardMenuPopup';

// Styles
import './CurrentBoardMenuUtil.scss';
import { PopupIds } from '../../../../components/popupPanel/popupConstants';

const CurrentBoardMenuUtil = (props) => (
    <CurrentBoardHeaderUtil className="CurrentBoardMenuUtil">
        <PopupToolButton popupId={PopupIds.CURRENT_BOARD_MENU} icon={<Icon name="menu-ellipsis" />} />
        <PopupPanel popupId={PopupIds.CURRENT_BOARD_MENU} className="CurrentBoardMenuPopupPanel" {...props}>
            <CurrentBoardMenuPopup {...props} />
        </PopupPanel>
    </CurrentBoardHeaderUtil>
);

CurrentBoardMenuUtil.propTypes = {
    currentBoardId: PropTypes.string,
};

export default CurrentBoardMenuUtil;
